import React from "react";
import Styles from './styles.module.scss'
import {useTranslation} from "react-i18next";
import CustomBorder from "../_UI/customBorder";

import img from '../../theme/assets/other/tc_apostol_s2_bg.png';
import {useNavigate} from "react-router-dom";



const ApostolS2 = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap} ${Styles.pageContainer}`}>
                <div className={`${Styles.contentBox}`}>
                    <div className={`${Styles.textWrap}`}>
                        <div className={`${Styles.title}`}>{t('Философия Апостолов')}</div>
                        <div className={`${Styles.noteColored}`}>{t('Во все эпохи знания передавались через людей. Не через системы — через носителей смысла.')}</div>
                        <div className={`${Styles.note}`}>{t('Апостолы Тайм Капсулы — это те, кто осознанно участвует в формировании цифровой цивилизации. Они не просто приглашают пользователей. Они распространяют идею сохранения личности и исторической памяти. Если Тайм Капсула — это цифровая форма продолжения, то Апостолы — это проводники этой формы в реальный мир.')}</div>
                        <div className={`${Styles.listWrap}`}>
                            <div className={`${Styles.listTitle}`}>{t('Апостол получает:')}</div>
                            <ul>
                                <li>{t('персональный цифровой идентификатор')}</li>
                                <li>{t('реферальную ссылку')}</li>
                                <li>{t('прозрачную систему начислений')}</li>
                                <li>{t('долю вознаграждения за каждую созданную капсулу')}</li>
                            </ul>
                        </div>
                        <div className={`${Styles.noteBordered}`}>{t('Каждый приглашённый участник, прошедший процесс оцифровки личности, фиксируется в системе как вклад Апостола в расширение цифровой цивилизации.')}</div>
                        <div className={`${Styles.btnWrap}`}>
                            <CustomBorder corners={{ topRight: true, bottomLeft: true }} fill="#1A1600" borderColor="#FFD700" withHover={true}>
                                <button className={`${Styles.btn}`} onClick={()=>{navigate('/sign-in')}}><div>{t('Стать апостолом')}</div></button>
                            </CustomBorder>
                        </div>
                    </div>
                    <div className={`${Styles.imgWrap}`}>
                        <img src={img} alt={t('Философия Апостолов')}/>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ApostolS2;